module.exports = __webpack_public_path__ + "img/94624F_573529_24110C_733424-256px.87e4fe1e.png";